module.exports = {
    playerExists: "Player with that name already exists"
}